import { gql } from '@grandvisionhq/graphql';

const GET_PRODUCTS_BY_SKUS = gql`
  query GetProductsBySKUs($skus: [String!]!) {
    getProductsBySKUs(skus: $skus) {
      name
      slug
      brand
      productType
      name
      nameAllLocales {
        locale
        value
      }
      ... on ContactLensProduct {
        id
        productTypeDetails {
          replacementFrequencyAllLocales {
            locale
            value
          }
        }
      }
      variants {
        ... on Variant {
          sku
          description
          displayName
          tags {
            key
            value
          }
          bestPrice
          priceList {
            priceType
            pricePerUnit {
              amount
              currencyCode
            }
            originalPrice {
              amount
              currencyCode
            }
            discountedPrice {
              price {
                amount
                currencyCode
              }
              discountInformation {
                type
                value
                description {
                  value
                  locale
                }
              }
            }
          }
          media {
            images {
              url
              dimensions {
                w
                h
              }
              label
            }
          }
        }
        ... on FrameVariant {
          variantTypeDetails {
            isInsuranceReimbursable
          }
        }
        ... on SolutionVariant {
          variantTypeDetails {
            contactLensCareType
            volume
            volumeUnit
          }
        }
      }
    }
  }
`;

export { GET_PRODUCTS_BY_SKUS };
//# sourceMappingURL=get-products-by-skus.js.map
